module.exports = __webpack_public_path__ + "static/img/Horse.0c00d26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Horse.svg
// module id = 1361
// module chunks = 0